import type { RouteRecordRaw } from 'vue-router';

import { accountRoutes } from '@/router/routes/private/account';
import { dealRoutes } from '@/router/routes/private/deal';
import { bankPartnerRoutes } from '@/router/routes/private/financialInstitution';
import { notificationsRoutes } from '@/router/routes/private/notifications';
import { pipelineRoutes } from '@/router/routes/private/pipeline';
import { productsRoutes } from '@/router/routes/private/product';
import { reportRoutes } from '@/router/routes/private/reports';
import { simulationRoutes } from '@/router/routes/private/simulation';
import { trainingRoutes } from '@/router/routes/private/training';

/**
 * Ambiente autenticado
 */
export const privateRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Base',
    path: '/',
    meta: { requiresAuth: true },
    redirect: '/account/dashboard',
    component: () => import('@/views/private/PrivateLayout.vue'),
    children: [
      {
        name: 'Users',
        path: 'users',
        component: () => import('@/views/private/account/ManageUsers.vue'),
      },

      {
        name: 'Subsidiary',
        path: 'subsidiary',
        component: () => import('@/views/private/subsidiary/Index.vue'),
      },
      {
        name: 'Simulations',
        path: 'simulations',
        component: () => import('@/views/private/simulations/list/Index.vue'),
      },
      {
        name: 'Commissions',
        path: 'commissions',
        component: () =>
          import('@/views/private/commissions/CommissionView.vue'),
      },
      {
        name: 'Activities',
        path: 'activities',
        component: () =>
          import('@/views/private/activities/ActivityManagement.vue'),
      },
      {
        name: 'Simulation',
        path: 'simulation',
        component: () =>
          import('@/views/private/simulations/SimulationsMainPage.vue'),
        children: simulationRoutes,
      },

      {
        name: 'VehicleSimulation',
        path: 'simulation/vehicle',
        component: () =>
          import('@/views/private/simulations/vehicle/Index.vue'),
      },
      {
        name: 'Courses',
        path: 'courses',
        component: () => import('@/views/private/courses/ListCourses.vue'),
      },
      {
        name: 'Customers',
        path: 'customers',
        component: () => import('@/views/private/customer/ListCustomer.vue'),
      },
      {
        name: 'Account',
        path: 'account',
        children: accountRoutes,
      },

      {
        name: 'ProductsGroup',
        path: 'products',
        children: productsRoutes,
        component: () => import('@/views/private/products/ProductView.vue'),
      },
      {
        name: 'SoftwareRelease',
        path: 'settings/softwareRelease',
        component: () => import('@/views/private/settings/softwareRelease.vue'),
      },
      {
        name: 'reports',
        path: 'reports',
        children: reportRoutes,
        component: () =>
          import('@/views/private/reports/IndicatorByProductView.vue'),
      },

      ...dealRoutes,
      ...pipelineRoutes,
      ...bankPartnerRoutes,
      ...reportRoutes,
      ...trainingRoutes,
      ...notificationsRoutes,
    ],
  },
  {
    name: 'Payment',
    path: '/payment',
    meta: { requiresAuth: true },
    component: () => import('@/views/private/account/Payment.vue'),
  },
  {
    name: 'ParameterizedPayment',
    path: '/payment/:plan',
    meta: { requiresAuth: true },
    component: () => import('@/views/private/account/Payment.vue'),
  },
];
